export const buildDate = import.meta.env.BUILD_DATE;

// eslint-disable-next-line no-console
console.log("ISO build date:", buildDate);
// eslint-disable-next-line no-console
console.log("Local build date:", new Date(buildDate).toLocaleString());

const BUILD_DATE_KEY = "BUILD_DATE_KEY";
const buildDateFromStorage = localStorage.getItem(BUILD_DATE_KEY);
if (!buildDateFromStorage || buildDate !== buildDateFromStorage) {
  localStorage.clear();
  localStorage.setItem(BUILD_DATE_KEY, buildDate);
}
